import { useEffect, useState } from 'react';

type Breakpoints<T> = Record<number, T>;

export default function useBreakpoint<T>(breakpoints: Breakpoints<T>): T {
    const [active, setActive] = useState<T>(() => getActiveBreakpoint(breakpoints));

    useEffect(() => {
        const handleResize = () => setActive(getActiveBreakpoint(breakpoints));
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [breakpoints]);

    return active;
}

function getActiveBreakpoint<T>(breakpoints: Breakpoints<T>): T {
    const width = typeof window !== 'undefined' ? window.innerWidth : 0;
    const sorted = Object.keys(breakpoints)
        .map(Number)
        .sort((a, b) => a - b);

    let active = breakpoints[sorted[0]];
    for (const bp of sorted) {
        if (width >= bp) active = breakpoints[bp];
    }
    return active;
}

